import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "whatscovered-nav hammodal" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Property Damage Liability", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "poweredby-hotspot" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "poweredby" }, "Provided by Assurant"),
  /*#__PURE__*/_createElementVNode("p", { class: "poweredby-content" }, " In all states, unless otherwise noted, Renters Insurance is underwritten by American Bankers Insurance Company of Florida with its home office in Miami, Florida. In Minnesota, the underwriter is American Security Insurance company. In Georgia, Residents Liability is underwritten by Voyager Indemnity Insurance Company. In Utah, coverage is provided under policy form AJ8850PC-0307 or AJ9281CKK-0609. The trade name Assurant is used to associate their products and services, and to connect with the brand of their parent company, Assurant, Inc. ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " Property Damage Liability insurance covers damages to your college dorm, landlord's apartment, or your neighbor's property when you are at fault. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " Property covered under this policy would be items the rental unit came with (e.g. stove, fridge, sink, toilet) or the building itself. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " If you are liable for damages, renters insurance can help save you the stress of having to pay out-of-pocket. When a covered incident happens, all you have to take care of is a small deductible – we’ll cover the Rest Rest easy and have peace of mind. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h5", null, "Incidents Covered", -1)
const _hoisted_11 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "whatscovered-bullets"
}
const _hoisted_12 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Fire"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Like a grease fire resulting in damage to to the kitchen counters and appliances. ")
], -1)
const _hoisted_15 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Water *"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Left the sink on? We’ll cover damage to the floor & the neighbor’s items on the floor below you. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", null, "*In North Carolina, water damage liability is optional for renters insurance.")
], -1)
const _hoisted_18 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Smoke"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Leaving candles unattended may result in in smoke damage. ")
], -1)
const _hoisted_21 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Explosion"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Science experiment gone wrong? We’ll We’ll cover the damage! ")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h5", null, "Includes Personal Liability", -1)
const _hoisted_28 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "whatscovered-bullets"
}
const _hoisted_29 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", null, " If a guest gets injured, the insurer will cover the necessary medical and legal expenses. ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = { style: {"line-height":"22px"} }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h4", null, "Personal Property Coverage", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "poweredby-hotspot" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "poweredby" }, "Provided by Assurant"),
  /*#__PURE__*/_createElementVNode("p", { class: "poweredby-content" }, " In all states, unless otherwise noted, Renters Insurance is underwritten by American Bankers Insurance Company of Florida with its home office in Miami, Florida. In Minnesota, the underwriter is American Security Insurance company. In Georgia, Residents Liability is underwritten by Voyager Indemnity Insurance Company. In Utah, coverage is provided under policy form AJ8850PC-0307 or AJ9281CKK-0609. The trade name Assurant is used to associate their products and services, and to connect with the brand of their parent company, Assurant, Inc. ")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, " Personal Property Coverage will cover your TV, furniture, small appliances, bike, guitar, classroom materials, and more! Think about how much it would cost to replace all your belongings if there was a fire, water damage, or burglary in your dorm. You will be reimbursed for what it it costs to repair or replace your things. ", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h5", null, "Incidents Covered", -1)
const _hoisted_43 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "whatscovered-bullets"
}
const _hoisted_44 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_45 = ["src"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Theft & Vandalism"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Was your gaming system stolen? We’ll make sure you have a replacement in no time! ")
], -1)
const _hoisted_47 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_48 = ["src"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Fire, Water Damage & Other Covered Perils"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Did your apartment get flooded? Get reimbursed for items that got destroyed. ")
], -1)
const _hoisted_50 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_51 = ["src"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Power Surge By Lightning"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Computer not working after a storm? We will help you get it repaired! ")
], -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { style: {"padding":"20px 0px","color":"#777","letter-styling":"italics"} }, [
  /*#__PURE__*/_createElementVNode("small", null, "Also Covered: Smoke, Explosion, Windstorm, Hail, Ice, Snow, Sleet, Pipe Pipe Bursts, Cracked AC, Water/Heating System, Freezing, Volcanic Eruption ")
], -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("h5", null, "Items covered", -1)
const _hoisted_58 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "whatscovered-bullets"
}
const _hoisted_59 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_60 = ["src"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("td", null, " Laptops, Tablets, Cell Phones, TVs, Blu-ray Players, Game Consoles, Consoles, Cameras, Clothing, Jewelry, Sports Equipment, Musical Instruments, Books, Furniture, Appliances and more. ", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_65 = { style: {"line-height":"22px"} }

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CoveredModal',
  setup(__props) {

const pageNumber = ref(1);
// This function is not used
// const assurantBookletPath: ComputedRef<string> = computed(() => {
//   return window.location.href + "assets/assurantpolicybooklet.pdf";
// });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        id: "whatscoveredabutton",
        class: _normalizeClass({ active: pageNumber.value == 1 }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (pageNumber.value = 1))
      }, " Property Damage & Personal Liability ", 2),
      _createElementVNode("span", {
        id: "whatscoveredabutton",
        class: _normalizeClass({ active: pageNumber.value == 2 }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (pageNumber.value = 2))
      }, " Personal Property Coverage ", 2)
    ]),
    _createElementVNode("div", {
      class: "whatscoveredwindow",
      style: _normalizeStyle([pageNumber.value == 1 ? { display: 'block' } : { display: 'none' }])
    }, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _createElementVNode("table", _hoisted_11, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_12, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon1.svg'),
                alt: "Fire"
              }, null, 8, _hoisted_13)
            ]),
            _hoisted_14
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_15, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon10.svg'),
                alt: "Water Flood"
              }, null, 8, _hoisted_16)
            ]),
            _hoisted_17
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_18, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon11.svg'),
                alt: "Smoke Damage"
              }, null, 8, _hoisted_19)
            ]),
            _hoisted_20
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_21, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon12.svg'),
                alt: "Explosion"
              }, null, 8, _hoisted_22)
            ]),
            _hoisted_23
          ])
        ])
      ]),
      _hoisted_24,
      _hoisted_25,
      _hoisted_26,
      _hoisted_27,
      _createElementVNode("table", _hoisted_28, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_29, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon2.svg'),
                alt: "Personal Injury Renters Insurance"
              }, null, 8, _hoisted_30)
            ]),
            _hoisted_31
          ])
        ])
      ]),
      _hoisted_32,
      _hoisted_33,
      _hoisted_34,
      _createElementVNode("p", null, [
        _createElementVNode("small", _hoisted_35, [
          _createTextVNode(" See your proof of insurance booklet (provided after purchase) to view complete coverage details including limitations and exclusions (terms and conditions). Coverages vary by state. "),
          _createVNode(_component_router_link, { to: { name: 'legalAssurant' } }, {
            default: _withCtx(() => [
              _createTextVNode("Assurant underwriter")
            ]),
            _: 1
          })
        ])
      ])
    ], 4),
    _createElementVNode("div", {
      class: "whatscoveredwindow",
      style: _normalizeStyle([pageNumber.value == 2 ? { display: 'block' } : { display: 'none' }])
    }, [
      _hoisted_36,
      _hoisted_37,
      _hoisted_38,
      _hoisted_39,
      _hoisted_40,
      _hoisted_41,
      _hoisted_42,
      _createElementVNode("table", _hoisted_43, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_44, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon15.svg'),
                alt: "Fire"
              }, null, 8, _hoisted_45)
            ]),
            _hoisted_46
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_47, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon1.svg'),
                alt: "Fire"
              }, null, 8, _hoisted_48)
            ]),
            _hoisted_49
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_50, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon14.svg'),
                alt: "Fire"
              }, null, 8, _hoisted_51)
            ]),
            _hoisted_52
          ])
        ])
      ]),
      _hoisted_53,
      _hoisted_54,
      _hoisted_55,
      _hoisted_56,
      _hoisted_57,
      _createElementVNode("table", _hoisted_58, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_59, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon13.svg'),
                alt: "Items Covered"
              }, null, 8, _hoisted_60)
            ]),
            _hoisted_61
          ])
        ])
      ]),
      _hoisted_62,
      _hoisted_63,
      _hoisted_64,
      _createElementVNode("p", null, [
        _createElementVNode("small", _hoisted_65, [
          _createTextVNode(" See your proof of insurance booklet (provided after purchase) to view complete coverage details including limitations and exclusions (terms and conditions). Coverages vary by state. "),
          _createVNode(_component_router_link, { to: { name: 'legalAssurant' } }, {
            default: _withCtx(() => [
              _createTextVNode("Assurant underwriter")
            ]),
            _: 1
          })
        ])
      ])
    ], 4)
  ], 64))
}
}

})